import React from "react";
import { Navigate } from "react-router-dom";

export default function ComplianceHome() {
  return <Navigate to="/admin/compliance/vehicles" replace />;
}
